import getGlossData from './getGlossData.gql?raw';
import getGlossVersion from './getGlossVersion.gql?raw';

export const getGlossDataQuery = getGlossData;
export const getGlossVersionQuery = getGlossVersion;
